import type { Envelope } from '@/api/envelopes';

/** `sortOrder` ascending (nulls last), then name. Unassigned is not an envelope (TMMAPI-0145): it is pinned by the page. */
export function orderEnvelopes(envelopes: Envelope[]): Envelope[] {
  return [...envelopes].sort((a, b) => {
    const orderA = a.sortOrder ?? Number.POSITIVE_INFINITY;
    const orderB = b.sortOrder ?? Number.POSITIVE_INFINITY;
    if (orderA !== orderB) return orderA - orderB;
    return a.name.localeCompare(b.name);
  });
}

/** The `sortOrder` a newly created envelope takes: after every existing one. */
export function nextSortOrder(envelopes: Envelope[]): number {
  return envelopes.reduce((max, envelope) => Math.max(max, envelope.sortOrder ?? -1), -1) + 1;
}

/**
 * `sortOrder` for an optimistic reorder. Ids are the posted list (1-based). An envelope that is not in
 * that list — an archived row — keeps the order it already has.
 */
export function withActiveSortOrder(envelopes: Envelope[], ids: readonly number[]): Envelope[] {
  const order = new Map(ids.map((id, index) => [id, index + 1]));
  return envelopes.map((envelope) => {
    const next = order.get(envelope.id);
    return next === undefined ? envelope : { ...envelope, sortOrder: next };
  });
}
